import { render, staticRenderFns } from "./modalCancelarFatura.vue?vue&type=template&id=9f96b9ee&"
import script from "./modalCancelarFatura.vue?vue&type=script&lang=js&"
export * from "./modalCancelarFatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports